export const DARK_LOGIN_SVG =
  "https://d14giuafm9ljvl.cloudfront.net/uploads/74ba4084-2400-44a1-9d88-b143e6a5e49f/original/fondo-curvo-dark_c7d2d4bfe152a3db7408f206d15737eb.svg";
export const LIGHT_LOGIN_SVG =
  "https://d14giuafm9ljvl.cloudfront.net/uploads/c8946989-ca87-49e2-a664-53414ca59658/original/fondo-curvo_ee8efb1874852623e36615a986384c75.svg";

/** EVENTS FOR TRANLATIONS */
export const I18N_CHANGE_LANGUAGE = "CHANGE::LANGUAGE";
export const ERROR_EVENT_MESSAGE =
  "You should pass a detail.lang parameter in custom event";

export const LANGUAGE_OPTIONS = (t: Function) => {
  return [
    {
      label: t("Languages.es"),
      value: "es",
    },
    {
      label: t("Languages.en"),
      value: "en",
    },
  ];
};

export const CURRENCY_FORMAT_OPTIONS = (t: Function) => {
  return [
    {
      label: `${t("InitialConfiguration.commaOptionLabel")} (,)`,
      value: ",",
    },
    {
      label: `${t("InitialConfiguration.pointOptionLabel")} (.)`,
      value: ".",
    },
  ];
};

export const SECURITY_CODE_LENGTH_OPTIONS = [
  {
    label: "4",
    value: "4",
  },
  {
    label: "6",
    value: "6",
  },
  {
    label: "8",
    value: "8",
  },
  {
    label: "10",
    value: "10",
  },
];

export const SECURITY_CODE_TYPE_OPTIONS = (t: Function) => {
  return [
    {
      label: t("Security.alphaNumericOptionLabel"),
      value: "false",
    },
    {
      label: t("Security.numericOptionLabel"),
      value: "true",
    },
  ];
};

export const PRODUCT_STATUS_OPTIONS = [
  {
    label: "ACTIVE",
    value: "ACTIVE",
  },
  {
    label: "INACTIVE",
    value: "INACTIVE",
  },
];

export const TRX_TYPE_OPTIONS = (t: Function) => {
  return [
    {
      label: t("Transactions.transferTypeLabel"),
      value: "TRANSFER",
    },
    {
      label: t("Transactions.paymentTypeLabel"),
      value: "PAYMENT",
    },
    {
      label: t("Transactions.creditcardadvanceTypeLabel"),
      value: "CREDITCARDADVANCE",
    },
    {
      label: t("Transactions.psepaymentTypeLabel"),
      value: "PSEPAYMENT",
    },
  ];
};

export const TRX_STATES_OPTIONS = (t: Function) => {
  return [
    {
      label: t("Transactions.activeStatusLabel"),
      value: "ACTIVE",
    },
    {
      label: t("Transactions.inactiveStatusLabel"),
      value: "INACTIVE",
    },
  ];
};

export const TRX_BENEFICIARY_OPTIONS = (t: Function) => {
  return [
    {
      label: t("Transactions.sameBankTypeLabel"),
      value: "SAMEBANK",
    },
    {
      label: t("Transactions.sameBankUSATypeLabel"),
      value: "SAMEBANKUSA",
    },
    {
      label: t("Transactions.otherBankTypeLabel"),
      value: "OTHERBANK",
    },
    {
      label: t("Transactions.otherBankUSATypeLabel"),
      value: "OTHERBANKUSA",
    },
    {
      label: t("Transactions.wireTypeLabel"),
      value: "WIRE",
    },
    {
      label: t("Transactions.wireUSATypeLabel"),
      value: "WIREUSA",
    },
    {
      label: t("Transactions.noApplyTypeLabel"),
      value: "",
    },
  ];
};

export const MP_SERVICEAPI_OPTIONS = (t: Function) => {
  return [
    {
      label: t("MappedFields.paymentDetailLabel"),
      value: "paymentDetail",
    },
    {
      label: t("MappedFields.productBalanceLabel"),
      value: "productBalance",
    },
    {
      label: t("MappedFields.productDetailLabel"),
      value: "productDetail",
    },
    {
      label: t("MappedFields.transactionsLabel"),
      value: "transactions",
    },
  ];
};

export const MP_DASHBOARD_OPTIONS = (t: Function) => {
  return [
    {
      label: t("MappedFields.aliasLabel"),
      value: "alias",
    },
    {
      label: t("MappedFields.balanceLabel"),
      value: "balance",
    },
    {
      label: t("MappedFields.franchiseLabel"),
      value: "franchise",
    },
    {
      label: t("MappedFields.productNumberLabel"),
      value: "productNumber",
    },
    {
      label: t("MappedFields.notApply"),
      value: "",
    },
  ];
};

export const MP_DATATYPES_OPTIONS = (t: Function) => {
  return [
    {
      label: t("MappedFields.datetimeLabel"),
      value: "DATETIME",
    },
    {
      label: t("MappedFields.textLabel"),
      value: "TEXT",
    },
    {
      label: t("MappedFields.decimalLabel"),
      value: "DECIMAL",
    },
    {
      label: t("MappedFields.currencyLabel"),
      value: "CURRENCY",
    },
    {
      label: t("MappedFields.statusLabel"),
      value: "STATUS",
    },
    {
      label: t("MappedFields.integerLabel"),
      value: "INTEGER",
    },
    {
      label: t("MappedFields.dateLabel"),
      value: "DATE",
    },
    {
      label: t("MappedFields.daysLabel"),
      value: "DAYS",
    },
  ];
};

export const TRANSLATION_LABELTYPE_OPTIONS = (t: Function) => {
  return [
    {
      label: t("Translations.badgeOptionLabel"),
      value: "Badge",
    },
    {
      label: t("Translations.breadcrumbsOptionLabel"),
      value: "Breadcrumbs",
    },
    {
      label: t("Translations.buttonOptionLabel"),
      value: "Button",
    },
    {
      label: t("Translations.columntitleOptionLabel"),
      value: "ColumnTitle",
    },
    {
      label: t("Translations.descriptionOptionLabel"),
      value: "Description",
    },
    {
      label: t("Translations.optionlabelOptionLabel"),
      value: "OptionLabel",
    },
    {
      label: t("Translations.linkOptionLabel"),
      value: "Link",
    },
    {
      label: t("Translations.messageOptionLabel"),
      value: "Message",
    },
    {
      label: t("Translations.placeholderOptionLabel"),
      value: "Placeholder",
    },
    {
      label: t("Translations.subtitleOptionLabel"),
      value: "Subtitle",
    },
    {
      label: t("Translations.tagOptionLabel"),
      value: "Tag",
    },
    {
      label: t("Translations.titleOptionLabel"),
      value: "Title",
    },
    {
      label: t("Translations.tooltipOptionLabel"),
      value: "Tooltip",
    },
    {
      label: t("Translations.labelOptionLabel"),
      value: "Label",
    },
  ];
};

export const IM_CAMPAIGN_TYPES = (t: Function) => {
  return [
    {
      label: t("IuviMarketing.loginOptionLabel"),
      value: "Login",
    },
    {
      label: t("IuviMarketing.dashboardOptionLabel"),
      value: "Dashboard",
    },
    {
      label: t("IuviMarketing.mobileLogin"),
      value: "MobileLogin",
    },
    {
      label: t("IuviMarketing.mobileDashboard"),
      value: "MobileDashboard",
    },
  ];
};

export const REVALIDATE_FORM_PROPS = {
  shouldValidate: true,
  shouldDirty: true,
  shouldTouch: true,
};

export const AGENTS_STATUS_OPTIONS = (t: Function) => {
  return [
    {
      label: t("Agents.activeLabel"),
      value: "ACTIVE",
    },
    {
      label: t("Agents.inactiveLabel"),
      value: "INACTIVE",
    },
    {
      label: t("Agents.draftLabel"),
      value: "DRAFT",
    },
    // {
    //   label: t("Agents.deletedLabel"),
    //   value: "DELETED",
    // },
  ];
};

export const PERMISSIONS_STATUS_OPTIONS = (t: Function) => {
  return [
    {
      label: t("Permissions.ACTIVELabel"),
      value: "ACTIVE",
    },
    {
      label: t("Permissions.INACTIVELabel"),
      value: "INACTIVE",
    },
    {
      label: t("Permissions.DRAFTLabel"),
      value: "DRAFT",
    },
    // {
    //   label: t("Permissions.DELETEDLabel"),
    //   value: "DELETED",
    // },
  ];
};

export const FUNCTIONALITIES_STATUS_OPTIONS = (t: Function) => {
  return [
    {
      label: t("Permissions.ACTIVELabel"),
      value: "ACTIVE",
    },
    {
      label: t("Permissions.INACTIVELabel"),
      value: "INACTIVE",
    },
    {
      label: t("Permissions.DRAFTLabel"),
      value: "DRAFT",
    },
    // {
    //   label: t("Permissions.DELETEDLabel"),
    //   value: "DELETED",
    // },
  ];
};

export const ConfigsExportOptions = [
  {
    label: "FormatAndLanguagesLabel",
    value: "formatsandlanguages",
  },
  {
    label: "EndpointLabel",
    value: "endpointosp",
  },
  {
    label: "FieldValidationsLabel",
    value: "fieldvalidations",
  },
  {
    label: "FieldMappingLabel",
    value: "mappedfields",
  },
  {
    label: "TextsAndMessagesFrontLabel",
    value: "translations",
  },
  {
    label: "WidgetFunctionalityLabel",
    value: "widgets",
  },
  {
    label: "TransversalLabel",
    value: "globals",
  },
  {
    label: "QuickLinksLabel",
    value: "quicklinks",
  },
  {
    label: "AutenticationAndSecurityLabel",
    value: "security",
  },
  {
    label: "ProductsConfigurationsLabel",
    value: "products",
  },
  {
    label: "TransfersLabel",
    value: "transfers",
  },
  {
    label: "MobileLabel",
    value: "mobile",
  },
  {
    label: "IuviMARKETINGLabel",
    value: "iuvimarketing",
  },
  {
    label: "IuviNOWLabel",
    value: "iuvinow",
  },
  {
    label: "IuviPROFILERLabel",
    value: "iuviprofiler",
  },
  {
    label: "IuviSALESLabel",
    value: "iuvisales",
  },
  {
    label: "FindMyBankLabel",
    value: "findmybank",
  },
  {
    label: "AdministrativeTransfersLabel",
    value: "administrative",
  },
];

export const APPLICATION_STATES = (t: Function) => {
  return [
    {
      label: t("Applications.activeStatusLabel"),
      value: "ACTIVE",
    },
    {
      label: t("Applications.inactiveStatusLabel"),
      value: "INACTIVE",
    },
    {
      label: t("Applications.draftStatusLabel"),
      value: "DRAFT",
    }
  ];
};

export const TENANT_STATES = (t: Function, showDeleteStatus = false) => {
  let status = [
    {
      label: t("Tenants.activeStatusLabel"),
      value: "ACTIVE",
    },
    {
      label: t("Tenants.inactiveStatusLabel"),
      value: "INACTIVE",
    },
    {
      label: t("Tenants.draftStatusLabel"),
      value: "DRAFT",
    },
  ];
  if (showDeleteStatus) {
    status.push({
      label: t("Tenants.deletedStatusLabel"),
      value: "DELETED",
    })
  }
  return status;
};

export const ENVIRONMENT_STATES = (t: Function) => {
  return [
    {
      label: t("Environments.activeStatusLabel"),
      value: "ACTIVE",
    },
    {
      label: t("Environments.inactiveStatusLabel"),
      value: "INACTIVE",
    },
    {
      label: t("Environments.draftStatusLabel"),
      value: "DRAFT",
    },
    {
      label: t("Environments.deletedStatusLabel"),
      value: "DELETED",
    },
  ];
};

export const CLONE_SEGMENT_OPTIONS = (t: Function) => {
  return [
    {
      label: t("Applications.retailLabel"),
      value: "RETAIL",
    },
    {
      label: t("Applications.corporateLabel"),
      value: "CORPORATE",
    },
  ];
};

export const RELEASE_VERSION_OPTIONS = [
  {
    label: "2022.Q4",
    value: "2022.Q4",
  },
  {
    label: "2023.Q1",
    value: "2023.Q1",
  },
  {
    label: "2023.Q2",
    value: "2023.Q2",
  },
];

export const CONFIGURATION_KEYS = {
  key: "string",
  value: "string",
  description: "string",
  type: "string",
  status: "string",
  iscustomconfiguration: "boolean",
  releaseversion: "string",
  widgets: "array",
  id: "number",
  createdat: "string",
  updatedat: "string",
};

export const IMPORT_KEYS_VALIDATION = {
  endpointosp: CONFIGURATION_KEYS,
  quicklinks: {
    name: "string",
    labelkey: "string",
    iconname: "string",
    linkto: "string",
    fieldorder: "number",
    isexternallink: "boolean",
    category: "number",
    status: "string",
    releaseversion: "string",
    type: "string",
    description: "string",
    issecuredurl: "boolean",
    id: "number",
    createdat: "string",
    updatedat: "string",
    level: "number",
    useimage: "boolean",
    showlabel: "boolean",

  },
  security: CONFIGURATION_KEYS,
  formatsandlanguages: {
    configurations: CONFIGURATION_KEYS,
    languages: {
      isocode: "string",
      isdefault: "boolean",
      status: "string",
      releaseversion: "string",
      id: "number",
      createdat: "string",
      updatedat: "string",
    },
  },
  iuvimarketing: {
    configurations: CONFIGURATION_KEYS,
    marketingcampaigns: {
      type: "string",
      advertiseid: "number",
      properties: "string",
      status: "string",
      releaseversion: "string",
      id: "number",
      createdat: "string",
      updatedat: "string",
    },
  },
  iuvinow: CONFIGURATION_KEYS,
  iuvisales: CONFIGURATION_KEYS,
  iuviprofiler: CONFIGURATION_KEYS,
  mappedfields: {
    name: "string",
    labelkey: "string",
    jsonpath: "string",
    extrajsonpath: "string",
    serviceapi: "string",
    datatype: "string",
    dashboardoption: "string",
    releaseversion: "string",
    description: "string",
    descriptionlabelkey: "string",
    id: "number",
    createdat: "string",
    updatedat: "string",
  },
  products: {
    configurations: CONFIGURATION_KEYS,
    information: {
      name: "string",
      nameinapi: "string",
      labelkey: "string",
      hastransactions: "boolean",
      fieldorder: "number",
      status: "string",
      releaseversion: "string",
      id: "number",
      createdat: "string",
      updatedat: "string",
      productproperties: {
        key: "string",
        value: "string",
        type: "string",
        productid: "number",
        releaseversion: "string",
        relation: "string",
        id: "number",
        createdat: "string",
        updatedat: "string",
      },
      productfields: {
        id: "number",
        mappedfieldid: "number",
        productid: "number",
        fieldorder: "number",
        usagetype: "string",
        status: "string",
        releaseversion: "string",
        relation: "string",
        fieldname: "string",
        createdat: "string",
        updatedat: "string",
      },
    },
  },
  productproperties: {
    key: "string",
    labelkey: "string",
    defaultvalue: "string",
    isdefaultforall: "boolean",
    type: "string",
    usagetype: "string",
    usagelist: "string",
    releaseversion: "string",
    description: "string",
    id: "number",
    createdat: "string",
    updatedat: "string",
  },
  transactionproperties: {
    key: "string",
    labelkey: "string",
    defaultvalue: "string",
    isdefaultforall: "boolean",
    type: "string",
    usagetype: "string",
    usagelist: "string",
    releaseversion: "string",
    description: "string",
    id: "number",
    createdat: "string",
    updatedat: "string",
  },
  findmybank: CONFIGURATION_KEYS,
  translations: {
    key: "string",
    description: "string",
    type: "string",
    widgets: ["string"],
    releaseversion: "string",
    id: "number",
    createdat: "string",
    updatedat: "string",
    translations: {
      value: "string",
      languageisocode: "string",
      labelid: "number",
      id: "number",
      createdat: "string",
      updatedat: "string",
    },
  },
  transfers: {
    name: "string",
    systemfunction: "string",
    labelkey: "string",
    wildcardcode: "number",
    authorizationflowname: "string",
    type: "string",
    beneficiaryregistrationtype: "string",
    isbatch: "boolean",
    fieldorder: "number",
    status: "string",
    releaseversion: "string",
    id: "number",
    createdat: "string",
    updatedat: "string",
    transactionproperties: {
      key: "string",
      value: "string",
      type: "string",
      transactionid: "number",
      releaseversion: "string",
      relation: "string",
      id: "number",
      createdat: "string",
      updatedat: "string",
    },
    transactionfields: {
      id: "number",
      mappedfieldid: "number",
      transactionid: "number",
      fieldorder: "number",
      status: "string",
      releaseversion: "string",
      relation: "string",
      fieldname: "string",
      createdat: "string",
      updatedat: "string",
    },
  },
  globals: CONFIGURATION_KEYS,
  fieldvalidations: CONFIGURATION_KEYS,
  mobile: CONFIGURATION_KEYS,
  administrative: CONFIGURATION_KEYS,
  widgets: {
    widgetname: "string",
    releaseversion: "string",
    description: "string",
    id: "number",
    createdat: "string",
    updatedat: "string",
  },
};

export const CURRENCY_OPTIONS = [
  {
    label: "AED",
    value: "AED",
  },
  {
    label: "AFN",
    value: "AFN",
  },
  {
    label: "ALL",
    value: "ALL",
  },
  {
    label: "AMD",
    value: "AMD",
  },
  {
    label: "ANG",
    value: "ANG",
  },
  {
    label: "AOA",
    value: "AOA",
  },
  {
    label: "ARS",
    value: "ARS",
  },
  {
    label: "AUD",
    value: "AUD",
  },
  {
    label: "AWG",
    value: "AWG",
  },
  {
    label: "AZN",
    value: "AZN",
  },
  {
    label: "BAM",
    value: "BAM",
  },
  {
    label: "BBD",
    value: "BBD",
  },
  {
    label: "BDT",
    value: "BDT",
  },
  {
    label: "BGN",
    value: "BGN",
  },
  {
    label: "BHD",
    value: "BHD",
  },
  {
    label: "BIF",
    value: "BIF",
  },
  {
    label: "BMD",
    value: "BMD",
  },
  {
    label: "BND",
    value: "BND",
  },
  {
    label: "BOB",
    value: "BOB",
  },
  {
    label: "BOV",
    value: "BOV",
  },
  {
    label: "BRL",
    value: "BRL",
  },
  {
    label: "BSD",
    value: "BSD",
  },
  {
    label: "BTN",
    value: "BTN",
  },
  {
    label: "BWP",
    value: "BWP",
  },
  {
    label: "BYN",
    value: "BYN",
  },
  {
    label: "BZD",
    value: "BZD",
  },
  {
    label: "CAD",
    value: "CAD",
  },
  {
    label: "CDF",
    value: "CDF",
  },
  {
    label: "CHE",
    value: "CHE",
  },
  {
    label: "CHF",
    value: "CHF",
  },
  {
    label: "CHW",
    value: "CHW",
  },
  {
    label: "CLF",
    value: "CLF",
  },
  {
    label: "CLP",
    value: "CLP",
  },
  {
    label: "CNY",
    value: "CNY",
  },
  {
    label: "COP",
    value: "COP",
  },
  {
    label: "COU",
    value: "COU",
  },
  {
    label: "CRC",
    value: "CRC",
  },
  {
    label: "CUC",
    value: "CUC",
  },
  {
    label: "CUP",
    value: "CUP",
  },
  {
    label: "CVE",
    value: "CVE",
  },
  {
    label: "CZK",
    value: "CZK",
  },
  {
    label: "DJF",
    value: "DJF",
  },
  {
    label: "DKK",
    value: "DKK",
  },
  {
    label: "DOP",
    value: "DOP",
  },
  {
    label: "DZD",
    value: "DZD",
  },
  {
    label: "EGP",
    value: "EGP",
  },
  {
    label: "ERN",
    value: "ERN",
  },
  {
    label: "ETB",
    value: "ETB",
  },
  {
    label: "EUR",
    value: "EUR",
  },
  {
    label: "FJD",
    value: "FJD",
  },
  {
    label: "FKP",
    value: "FKP",
  },
  {
    label: "GBP",
    value: "GBP",
  },
  {
    label: "GEL",
    value: "GEL",
  },
  {
    label: "GHS",
    value: "GHS",
  },
  {
    label: "GIP",
    value: "GIP",
  },
  {
    label: "GMD",
    value: "GMD",
  },
  {
    label: "GNF",
    value: "GNF",
  },
  {
    label: "GTQ",
    value: "GTQ",
  },
  {
    label: "GYD",
    value: "GYD",
  },
  {
    label: "HKD",
    value: "HKD",
  },
  {
    label: "HNL",
    value: "HNL",
  },
  {
    label: "HRK",
    value: "HRK",
  },
  {
    label: "HTG",
    value: "HTG",
  },
  {
    label: "HUF",
    value: "HUF",
  },
  {
    label: "IDR",
    value: "IDR",
  },
  {
    label: "ILS",
    value: "ILS",
  },
  {
    label: "INR",
    value: "INR",
  },
  {
    label: "IQD",
    value: "IQD",
  },
  {
    label: "IRR",
    value: "IRR",
  },
  {
    label: "ISK",
    value: "ISK",
  },
  {
    label: "JMD",
    value: "JMD",
  },
  {
    label: "JOD",
    value: "JOD",
  },
  {
    label: "JPY",
    value: "JPY",
  },
  {
    label: "KES",
    value: "KES",
  },
  {
    label: "KGS",
    value: "KGS",
  },
  {
    label: "KHR",
    value: "KHR",
  },
  {
    label: "KMF",
    value: "KMF",
  },
  {
    label: "KPW",
    value: "KPW",
  },
  {
    label: "KRW",
    value: "KRW",
  },
  {
    label: "KWD",
    value: "KWD",
  },
  {
    label: "KYD",
    value: "KYD",
  },
  {
    label: "KZT",
    value: "KZT",
  },
  {
    label: "label",
    value: "label",
  },
  {
    label: "LAK",
    value: "LAK",
  },
  {
    label: "LBP",
    value: "LBP",
  },
  {
    label: "LKR",
    value: "LKR",
  },
  {
    label: "LRD",
    value: "LRD",
  },
  {
    label: "LSL",
    value: "LSL",
  },
  {
    label: "LYD",
    value: "LYD",
  },
  {
    label: "MAD",
    value: "MAD",
  },
  {
    label: "MDL",
    value: "MDL",
  },
  {
    label: "MGA",
    value: "MGA",
  },
  {
    label: "MKD",
    value: "MKD",
  },
  {
    label: "MMK",
    value: "MMK",
  },
  {
    label: "MNT",
    value: "MNT",
  },
  {
    label: "MOP",
    value: "MOP",
  },
  {
    label: "MRU",
    value: "MRU",
  },
  {
    label: "MUR",
    value: "MUR",
  },
  {
    label: "MVR",
    value: "MVR",
  },
  {
    label: "MWK",
    value: "MWK",
  },
  {
    label: "MXN",
    value: "MXN",
  },
  {
    label: "MXV",
    value: "MXV",
  },
  {
    label: "MYR",
    value: "MYR",
  },
  {
    label: "MZN",
    value: "MZN",
  },
  {
    label: "NAD",
    value: "NAD",
  },
  {
    label: "NGN",
    value: "NGN",
  },
  {
    label: "NIO",
    value: "NIO",
  },
  {
    label: "NOK",
    value: "NOK",
  },
  {
    label: "NPR",
    value: "NPR",
  },
  {
    label: "NZD",
    value: "NZD",
  },
  {
    label: "OMR",
    value: "OMR",
  },
  {
    label: "PAB",
    value: "PAB",
  },
  {
    label: "PEN",
    value: "PEN",
  },
  {
    label: "PGK",
    value: "PGK",
  },
  {
    label: "PHP",
    value: "PHP",
  },
  {
    label: "PKR",
    value: "PKR",
  },
  {
    label: "PLN",
    value: "PLN",
  },
  {
    label: "PYG",
    value: "PYG",
  },
  {
    label: "QAR",
    value: "QAR",
  },
  {
    label: "RON",
    value: "RON",
  },
  {
    label: "RSD",
    value: "RSD",
  },
  {
    label: "RUB",
    value: "RUB",
  },
  {
    label: "RWF",
    value: "RWF",
  },
  {
    label: "SAR",
    value: "SAR",
  },
  {
    label: "SBD",
    value: "SBD",
  },
  {
    label: "SCR",
    value: "SCR",
  },
  {
    label: "SDG",
    value: "SDG",
  },
  {
    label: "SEK",
    value: "SEK",
  },
  {
    label: "SGD",
    value: "SGD",
  },
  {
    label: "SHP",
    value: "SHP",
  },
  {
    label: "SLE",
    value: "SLE",
  },
  {
    label: "SOS",
    value: "SOS",
  },
  {
    label: "SRD",
    value: "SRD",
  },
  {
    label: "SSP",
    value: "SSP",
  },
  {
    label: "STN",
    value: "STN",
  },
  {
    label: "SVC",
    value: "SVC",
  },
  {
    label: "SYP",
    value: "SYP",
  },
  {
    label: "SZL",
    value: "SZL",
  },
  {
    label: "THB",
    value: "THB",
  },
  {
    label: "TJS",
    value: "TJS",
  },
  {
    label: "TMT",
    value: "TMT",
  },
  {
    label: "TND",
    value: "TND",
  },
  {
    label: "TOP",
    value: "TOP",
  },
  {
    label: "TRY",
    value: "TRY",
  },
  {
    label: "TTD",
    value: "TTD",
  },
  {
    label: "TWD",
    value: "TWD",
  },
  {
    label: "TZS",
    value: "TZS",
  },
  {
    label: "UAH",
    value: "UAH",
  },
  {
    label: "UGX",
    value: "UGX",
  },
  {
    label: "USD",
    value: "USD",
  },
  {
    label: "USN",
    value: "USN",
  },
  {
    label: "UYI",
    value: "UYI",
  },
  {
    label: "UYU",
    value: "UYU",
  },
  {
    label: "UZS",
    value: "UZS",
  },
  {
    label: "VED",
    value: "VED",
  },
  {
    label: "VEF",
    value: "VEF",
  },
  {
    label: "VND",
    value: "VND",
  },
  {
    label: "VUV",
    value: "VUV",
  },
  {
    label: "WST",
    value: "WST",
  },
  {
    label: "XAF",
    value: "XAF",
  },
  {
    label: "XCD",
    value: "XCD",
  },
  {
    label: "XDR",
    value: "XDR",
  },
  {
    label: "XOF",
    value: "XOF",
  },
  {
    label: "XPF",
    value: "XPF",
  },
  {
    label: "XSU",
    value: "XSU",
  },
  {
    label: "XUA",
    value: "XUA",
  },
  {
    label: "YER",
    value: "YER",
  },
  {
    label: "ZAR",
    value: "ZAR",
  },
  {
    label: "ZMW",
    value: "ZMW",
  },
  {
    label: "ZWL",
    value: "ZWL",
  },
];

export const QUICKLINKS_TYPE_OPTIONS = (t: Function) => {
  return [
    {
      label: t("Quicklinks.quicklinkOptionLabel"),
      value: "quicklink",
    },
    {
      label: t("Quicklinks.speeddialOptionLabel"),
      value: "SPEEDDIAL",
    },
    {
      label: t("Quicklinks.footerOptionLabel"),
      value: "FOOTER",
    },
    {
      label: t("Quicklinks.helpcenterOptionLabel"),
      value: "HELPCENTER",
    },
    {
      label: t("Quicklinks.loginQuicklinkOptionLabel"),
      value: "LOGIN_QUICKLINK",
    },
    {
      label: t("Quicklinks.loginFooterlinkOptionLabel"),
      value: "LOGIN_FOOTER",
    },
  ];
};

export const INACTIVITY_MODAL_EVENT = "INACTIVITY::MODAL";
export const INACTIVITY_TIME = "INACTIVITY::TIME";
export const KEYCLOAK_HOST_DEV = "http://ibconsoleiam.k8.osp.com:8080";

export const enabledMaster = (t: Function) => {
  return [
    {
      label: t("Users.activeLabel"),
      value: "ACTIVE",
    },
    {
      label: t("Users.inactiveLabel"),
      value: "INACTIVE",
    },
  ];
};

export const locationMaster = (t: Function) => {
  return [
    {
      label: "Argentina",
      value: "Argentina",
    },
    {
      label: "Bogotá",
      value: "Bogotá",
    },
    {
      label: "Ecuador",
      value: "Ecuador",
    },
    {
      label: "Medellín",
      value: "Medellín",
    },
    {
      label: "Miami",
      value: "Miami",
    },
    {
      label: t("Users.otherLocationLabel"),
      value: "Otros",
    },
  ];
};

export const areaMaster = (t: Function) => {
  return [
    {
      label: "CISO and Corportate Audit",
      value: "CISO and Corportate Audit",
    },
    {
      label: "COO ( Chief Operation Officer)",
      value: "COO ( Chief Operation Officer)",
    },
    {
      label: "COO - Implementation Direction",
      value: "COO - Implementation Direction",
    },
    {
      label: "COO - Implementation Technical Direction",
      value: "COO - Implementation Technical Direction",
    },
    {
      label: "COO - Operations and Technlogy Direction",
      value: "COO - Operations and Technlogy Direction",
    },
    {
      label: "CPO (Chief Product Officer)",
      value: "CPO (Chief Product Officer)",
    },
    {
      label: "CDAO ( Chief Data Analytics Officer)",
      value: "CDAO ( Chief Data Analytics Officer)",
    },
  ];
};

export const functionMaster = (t: Function) => {
  return [
    {
      label: "Analista",
      value: "Analista",
    },
    {
      label: "Automatizador de pruebas",
      value: "Automatizador de pruebas",
    },
    {
      label: "Arquitecto",
      value: "Arquitecto",
    },
    {
      label: "Business Consultants",
      value: "Business Consultants",
    },
    {
      label: "Coordinador",
      value: "Coordinador",
    },
    {
      label: "Coordinador de Implementación Técnica",
      value: "Coordinador de Implementación Técnica",
    },
    {
      label: "Coordinador de Pruebas",
      value: "Coordinador de Pruebas",
    },
    {
      label: "Gerente",
      value: "Gerente",
    },
    {
      label: "Desarrollador Backend",
      value: "Desarrollador Backend",
    },
    {
      label: "Desarrollador Frontend",
      value: "Desarrollador Frontend",
    },
    {
      label: "Desarrollador Full Stack",
      value: "Desarrollador Full Stack",
    },
    {
      label: "Diseñador Experiencia de Usuario",
      value: "Diseñador Experiencia de Usuario",
    },
    {
      label: "Director",
      value: "Director",
    },
    {
      label: "Especialista de Diseño de Soluciones",
      value: "Especialista de Diseño de Soluciones",
    },
    {
      label: "Especialista de Operaciones",
      value: "Especialista de Operaciones",
    },
    {
      label: "Especialista de Servicios",
      value: "Especialista de Servicios",
    },
    {
      label: "Ingeniero DevOPs",
      value: "Ingeniero DevOPs",
    },
    {
      label: "Líder Técnico",
      value: "Líder Técnico",
    },
    {
      label: "Product Manager",
      value: "Product Manager",
    },
    {
      label: "Product Owner",
      value: "Product Owner",
    },
  ];
};

export const ConsoleTranslationsFunctionalities = (t: Function) => {
  return [
    {
      label: t("ConsoleTranslations.LoginOptionLabel"),
      value: "Login",
    },
    {
      label: t("ConsoleTranslations.OptionOptionLabel"),
      value: "Option",
    },
    {
      label: t("ConsoleTranslations.AppSelectorOptionLabel"),
      value: "AppSelector",
    },
    {
      label: t("ConsoleTranslations.DashboardOptionLabel"),
      value: "Dashboard",
    },
    {
      label: t("ConsoleTranslations.UserInformationOptionLabel"),
      value: "UserInformation",
    },
    {
      label: t("ConsoleTranslations.TableHeaderOptionLabel"),
      value: "TableHeader",
    },
    {
      label: t("ConsoleTranslations.InitialConfigurationOptionLabel"),
      value: "InitialConfiguration",
    },
    {
      label: t("ConsoleTranslations.GlobalConfigurationOptionLabel"),
      value: "GlobalConfiguration",
    },
    {
      label: t("ConsoleTranslations.SecurityOptionLabel"),
      value: "Security",
    },
    {
      label: t("ConsoleTranslations.MappedFieldsOptionLabel"),
      value: "MappedFields",
    },
    {
      label: t("ConsoleTranslations.QuicklinksOptionLabel"),
      value: "Quicklinks",
    },
    {
      label: t("ConsoleTranslations.TranslationsOptionLabel"),
      value: "Translations",
    },
    {
      label: t("ConsoleTranslations.LanguagesOptionLabel"),
      value: "Languages",
    },
    {
      label: t("ConsoleTranslations.MenuOptionLabel"),
      value: "Menu",
    },
    {
      label: t("ConsoleTranslations.ProductsOptionLabel"),
      value: "Products",
    },
    {
      label: t("ConsoleTranslations.TransactionsOptionLabel"),
      value: "Transactions",
    },
    {
      label: t("ConsoleTranslations.IuviMarketingOptionLabel"),
      value: "IuviMarketing",
    },
    {
      label: t("ConsoleTranslations.WidgetsOptionLabel"),
      value: "Widgets",
    },
    {
      label: t("ConsoleTranslations.AgentsOptionLabel"),
      value: "Agents",
    },
    {
      label: t("ConsoleTranslations.TenantsOptionLabel"),
      value: "Tenants",
    },
    {
      label: t("ConsoleTranslations.ApplicationsOptionLabel"),
      value: "Applications",
    },
    {
      label: t("ConsoleTranslations.EnvironmentsOptionLabel"),
      value: "Environments",
    },
    {
      label: t("ConsoleTranslations.VersionsOptionLabel"),
      value: "Versions",
    },
    {
      label: t("ConsoleTranslations.UsersOptionLabel"),
      value: "Users",
    },
    {
      label: t("ConsoleTranslations.ConsoleTranslationsOptionLabel"),
      value: "ConsoleTranslations",
    },
    {
      label: t("ConsoleTranslations.ConfirmationMessagesOptionLabel"),
      value: "ConfirmationMessages",
    },
    {
      label: t("ConsoleTranslations.ValidationMessagesOptionLabel"),
      value: "ValidationMessages",
    },
    {
      label: t("ConsoleTranslations.PointsOfAttentionOptionLabel"),
      value: "PointsOfAttention",
    }
  ];
};

export const servicesFields: (t: Function) => {}[] = (t: Function) => {
  return [
    {
      field: "name",
      header: t("PointsOfAttention.nameLabel"),
    },
    {
      field: "code",
      header: t("PointsOfAttention.codeLabel"),
    },
    {
      field: "pointServiceType",
      header: t("PointsOfAttention.pointServiceTypeLabel"),
    },
    {
      field: "description",
      header: t("PointsOfAttention.descriptionLabel"),
    },
    {
      field: "actions",
      header: t("PointsOfAttention.actionsLabel"),
    },
  ]
};

export const schedulesFields: (t: Function) => {}[] = (t: Function) => {
  return [
    {
      field: "day",
      header: t("PointsOfAttention.dayLabel"),
    },
    {
      field: "start",
      header: t("PointsOfAttention.startLabel"),
    },
    {
      field: "end",
      header: t("PointsOfAttention.endLabel"),
    },
    {
      field: "actions",
      header: t("PointsOfAttention.actionsLabel"),
    },
  ]
};

export const mastersFields: (t: Function) => {}[] = (t: Function) => {
  return [
    {
      field: "code",
      header: t("PointsOfAttention.codeLabel"),
    },
    {
      field: "name",
      header: t("PointsOfAttention.nameLabel"),
    },
    {
      field: "description",
      header: t("PointsOfAttention.descriptionLabel"),
    },
    {
      field: "layerImage",
      header: t("PointsOfAttention.layerImageLabel"),
    },
    {
      field: "layerName",
      header: t("PointsOfAttention.layerNameLabel"),
    },
    {
      field: "actions",
      header: t("PointsOfAttention.actionsLabel"),
    },
  ]
};

export const pointsFeatures = ['administration', 'manage_files', 'services', 'schedules', 'masters'];

export const SCHEDULE_DAYS: any = {
  Lunes: "MONDAY",
  Martes: "TUESDAY",
  Miércoles: "WEDNESDAY",
  Jueves: "THURSDAY",
  Viernes: "FRIDAY",
  Sábado: "SATURDAY",
  Domingo: "SUNDAY",
};

export const SCHEDULE_TYPES: any = {
  Extendido: "EXTENDED",
  Regular: "REGULAR",
  Festivos: "HOLIDAY",
  Intermitente: "INTERMITTENT",
};

export const basicInfoBoxFields = [
  {
    key: "pointServiceType",
    type: "dropdown",
  },
  {
    key: "phone",
    type: "phone",
  },
  {
    key: "name",
    type: "text",
  },
  {
    key: "startDate",
    type: "calendar",
  },
  {
    key: "code",
    type: "text",
  },
  {
    key: "endDate",
    type: "calendar",
  },
  {
    key: "observation",
    type: "textarea",
  },
];

export const locationBoxFields = [
  {
    key: "country",
    type: "dropdown",
  },
  {
    key: "address",
    type: "text",
  },
  {
    key: "department",
    type: "dropdown",
  },
  {
    key: "latitude",
    type: "text",
  },
  {
    key: "city",
    type: "dropdown",
  },
  {
    key: "longitude",
    type: "text",
  },
];

export const datatypeOfRegister: (t: Function) => {}[] = (t: Function) => {
  return [
    {
      label: t("PointsOfAttention.withoutDueDate"),
      value: 'WITHOUT_DUE_DATE'
    },
    {
      label: t("PointsOfAttention.withDueDate"),
      value: 'WITH_DUE_DATE'
    },
  ]
}

export const calendarTranslations = {
  "es": {
    "startsWith": "Comience con",
    "contains": "Contenga",
    "notContains": "No contenga",
    "endsWith": "Termine con",
    "equals": "Igual a",
    "notEquals": "Diferente a",
    "noFilter": "Sin filtro",
    "lt": "Menor que",
    "lte": "Menor o igual a",
    "gt": "Mayor que",
    "gte": "Mayor o igual a",
    "dateIs": "Fecha igual a",
    "dateIsNot": "Fecha diferente a",
    "dateBefore": "Fecha antes de",
    "dateAfter": "Fecha después de",
    "custom": "Personalizar",
    "clear": "Limpiar",
    "apply": "Aplicar",
    "matchAll": "Coincidir todo",
    "matchAny": "Coincidir con cualquiera",
    "addRule": "Agregar regla",
    "removeRule": "Eliminar regla",
    "accept": "Sí",
    "reject": "No",
    "choose": "Escoger",
    "upload": "Subir",
    "cancel": "Cancelar",
    "fileSizeTypes": [
      "B",
      "KB",
      "MB",
      "GB",
      "TB",
      "PB",
      "EB",
      "ZB",
      "YB"
    ],
    "dayNames": [
      "Domingo",
      "Lunes",
      "Martes",
      "Miércoles",
      "Jueves",
      "Viernes",
      "Sábado"
    ],
    "dayNamesShort": [
      "Dom",
      "Lun",
      "Mar",
      "Mié",
      "Jue",
      "Vie",
      "Sáb"
    ],
    "dayNamesMin": [
      "D",
      "L",
      "M",
      "M",
      "J",
      "V",
      "S"
    ],
    "monthNames": [
      "Enero",
      "Febrero",
      "Marzo",
      "Abril",
      "Mayo",
      "Junio",
      "Julio",
      "Agosto",
      "Septiembre",
      "Octubre",
      "Noviembre",
      "Diciembre"
    ],
    "monthNamesShort": [
      "Ene",
      "Feb",
      "Mar",
      "Abr",
      "May",
      "Jun",
      "Jul",
      "Ago",
      "Sep",
      "Oct",
      "Nov",
      "Dic"
    ],
    "today": "Hoy",
    "now": "Ahora",
    "weekHeader": "Sem",
    "firstDayOfWeek": 1,
    "showMonthAfterYear": false,
    "dateFormat": "dd/mm/yy",
    "weak": "Débil",
    "medium": "Medio",
    "strong": "Fuerte",
    "passwordPrompt": "Escriba una contraseña",
    "emptyFilterMessage": "Sin opciones disponibles",
    "emptySearchMessage": "Sin opciones disponibles",
    "emptyMessage": "No se han encontrado resultados",
    "aria": {
      "trueLabel": "Verdadero",
      "falseLabel": "Falso",
      "nullLabel": "No seleccionado",
      "star": "1 estrella",
      "stars": "{star} estrellas",
      "selectAll": "Seleccionar todos",
      "unselectAll": "Deseleccionar todos",
      "close": "Cerrar",
      "previous": "Anterior",
      "next": "Siguiente",
      "navigation": "Navegación",
      "scrollTop": "Desplazarse hacia arriba",
      "moveTop": "Mover arriba",
      "moveUp": "Subir",
      "moveDown": "Bajar",
      "moveBottom": "Desplazarse hacia abajo",
      "moveToTarget": "Mover al objetivo",
      "moveToSource": "Mover al origen",
      "moveAllToTarget": "Mover todo al objetivo",
      "moveAllToSource": "Mover todo al origen",
      "pageLabel": "Página {page}",
      "firstPageLabel": "Primera Página",
      "lastPageLabel": "Última Página",
      "nextPageLabel": "Siguiente Página",
      "previousPageLabel": "Página Anterior",
      "rowsPerPageLabel": "Filas por página",
      "jumpToPageDropdownLabel": "Ir al menú desplegable de página",
      "jumpToPageInputLabel": "Ir a la entrada de página",
      "selectRow": "Seleccionar fila",
      "unselectRow": "Desmarcar fila",
      "expandRow": "Expandir Fila",
      "collapseRow": "Reducir Fila",
      "showFilterMenu": "Mostrar menú del filtro",
      "hideFilterMenu": "Ocultar menú del filtro",
      "filterOperator": "Operador de filtro",
      "filterConstraint": "Restricción de filtro",
      "editRow": "Editar fila",
      "saveEdit": "Guardar editado",
      "cancelEdit": "Cancelar editado",
      "listView": "Vista de lista",
      "gridView": "Vista de cuadrícula",
      "slide": "Deslizar",
      "slideNumber": "{slideNumber}",
      "zoomImage": "Ampliar imagen",
      "zoomIn": "Ampliar",
      "zoomOut": "Reducir",
      "rotateRight": "Girar a la derecha",
      "rotateLeft": "Girar a la izquierda"
    }
  }
}

export const STATUS_PROCESS: any = {
  CREATED: 'CREATED',
  TRANSFORMING: 'TRANSFORMING',
  ERROR_TRANSFORMING: 'ERROR_TRANSFORMING',
  TRANSFORMED: 'TRANSFORMED',
  VALIDATING: 'VALIDATING',
  ERROR_VALIDATING: 'ERROR_VALIDATING',
  VALIDATED: 'VALIDATED',
  GENERATING_FILE: 'GENERATING_FILE',
  ERROR_GENERATING_FILE: 'ERROR_GENERATING_FILE',
  GENERATED_FILE: 'GENERATED_FILE',
  LOADING_FILE: 'LOADING_FILE',
  ERROR_LOADING_FILE: 'ERROR_LOADING_FILE',
  LOADED: 'LOADED',
  CANCELED: 'CANCELED'
}

export const STATUS_PROCESS_COLOR_TAG: any = {
  CREATED: 'success',
  TRANSFORMING: 'info',
  ERROR_TRANSFORMING: 'error',
  TRANSFORMED: 'info',
  VALIDATING: 'info',
  ERROR_VALIDATING: 'error',
  VALIDATED: 'info',
  GENERATING_FILE: 'info',
  ERROR_GENERATING_FILE: 'error',
  GENERATED_FILE: 'info',
  LOADING_FILE: 'info',
  ERROR_LOADING_FILE: 'error',
  LOADED: 'success',
  CANCELED: 'error'
}

export const THEMEINFO = {
  primarycolor: "#389bab",
  secondarycolor: "#33d07c",
}

export const infoQuicklinksFields = [
  {
    key: "name",
    type: "text",
    col: 1
  },
  {
    key: "description",
    type: "textarea",
    col: 1
  },
  {
    key: "showlabel",
    type: "boolean",
    col: 1
  },
  {
    key: "labelkey",
    type: "dropdown",
    col: 1
  },
  {
    key: "type",
    type: "dropdown",
    col: 2
  },
   {
    key: "level",
    type: "text",
    col: 2
  },
  {
    key: "issecuredurl",
    type: "boolean",
    col: 2
  },
  {
    key: "linkto",
    type: "textarea",
    col: 2
  },
  {
    key: "isexternallink",
    type: "boolean",
    col: 2
  },
  {
    key: "useimage",
    type: "boolean",
    col: 2
  },
  {
    key: "iconname",
    type: "text",
    col: 2
  },
  {
    key: "category",
    type: "text",
    col: 1
  },
  {
    key: "fieldorder",
    type: "text",
    col: 1
  },
  {
    key: "status",
    type: "boolean",
    col: 2
  },
  {
    key: "releaseversion",
    type: "dropdown",
    col: 2
  },
];

export const infoCampaignsFields = [
  {
    key: "clientId",
    type: "text",
    col: 1
  },
  {
    key: "groupId",
    type: "text",
    col: 1
  },
  {
    key: "companyId",
    type: "text",
    col: 1
  },
  {
    key: "providerDomain",
    type: "textarea",
    col: 1
  },
  {
    key: "urlMainJs",
    type: "textarea",
    col: 2
  },
  {
    key: "isEnabledMobile",
    type: "boolean",
    col: 2
  },
  {
    key: "isEnabledWeb",
    type: "boolean",
    col: 2
  },
];

export const campaignsCreatorFields = [
  {
    key: "advertiseid",
    type: "text",
    col: 1
  },
  {
    key: "type",
    type: "dropdown",
    col: 1
  },
  {
    key: "properties",
    type: "textarea",
    col: 2
  },
  {
    key: "status",
    type: "boolean",
    col: 2
  },
];

export const infoAgentsFields = [
  {
    key: "name",
    type: "text",
    col: 1
  },
  {
    key: "version",
    type: "text",
    col: 1
  },
  {
    key: "status",
    type: "dropdown",
    col: 1
  },
  {
    key: "url",
    type: "textarea",
    col: 2
  },
  {
    key: "publickey",
    type: "textarea",
    col: 2
  },
];

export const infoProductsFields = [
  {
    key: "name",
    type: "text",
    col: 1
  },
  {
    key: "nameinapi",
    type: "text",
    col: 1
  },
  {
    key: "labelkey",
    type: "dropdown",
    col: 1
  },
  {
    key: "hastransactions",
    type: "boolean",
    col: 2
  },
  {
    key: "releaseversion",
    type: "dropdown",
    col: 2
  },
];

export const infoPropertiesFields = [
  {
    key: "key",
    type: "text",
    col: 1
  },
  {
    key: "labelkey",
    type: "dropdown",
    col: 1
  },
  {
    key: "description",
    type: "textarea",
    col: 1
  },
  {
    key: "releaseversion",
    type: "dropdown",
    col: 1
  },
  {
    key: "type",
    type: "dropdown",
    col: 2
  },
  {
    key: "defaultvalue",
    type: "text",
    col: 2
  },
  {
    key: "isdefaultforall",
    type: "boolean",
    col: 2
  },
  {
    key: "usagelist",
    type: "multiselect",
    col: 2
  },
];

export const infoTransactionsFields = [
  {
    key: "name",
    type: "text",
    col: 1
  },
  {
    key: "labelkey",
    type: "dropdown",
    col: 1
  },
  {
    key: "type",
    type: "dropdown",
    col: 1
  },
  {
    key: "status",
    type: "dropdown",
    col: 1
  },
  {
    key: "beneficiaryregistrationtype",
    type: "dropdown",
    col: 2
  },
  {
    key: "isbatch",
    type: "boolean",
    col: 2
  },
  {
    key: "releaseversion",
    type: "dropdown",
    col: 2
  },
  {
    key: "fieldorder",
    type: "text",
    col: 2
  },
  {
    key: "systemfunction",
    type: "text",
    col: 1
  },
  {
    key: "wildcardcode",
    type: "text",
    col: 1
  },
  {
    key: "authorizationflowname",
    type: "text",
    col: 2
  },
];

export const functionalitiesFieldsSelecter = (action: string) => {
  switch (action) {
    case 'detail': return [
      {
        key: "key",
        type: "text",
        col: 1
      },
      {
        key: "code",
        type: "text",
        col: 1
      },
      {
        key: "keyLabelDescription",
        type: "textarea",
        col: 1
      },
      {
        key: "isAdministrative",
        type: "radioButton",
        col: 1
      },
      {
        key: "parentId",
        type: "dropdown",
        col: 1
      },
      {
        key: "categoryId",
        type: "dropdown",
        col: 2
      },
      {
        key: "keyLabel",
        type: "dropdown",
        col: 2
      },
      {
        key: "expeditionDate",
        type: "text",
        col: 2
      },
      {
        key: "expirationDate",
        type: "text",
        col: 2
      },
      {
        key: "statusId",
        type: "dropdown",
        col: 2
      },
    ];


    case 'update': return [
      {
        key: "key",
        type: "text",
        col: 1
      },
      {
        key: "code",
        type: "text",
        col: 1
      },
      {
        key: "keyLabelDescription",
        type: "textarea",
        col: 1
      },
      {
        key: "isAdministrative",
        type: "radioButton",
        col: 1
      },
      {
        key: "parentId",
        type: "dropdown",
        col: 1
      },
      {
        key: "categoryId",
        type: "dropdown",
        col: 2
      },
      {
        key: "keyLabel",
        type: "dropdown",
        col: 2
      },
      {
        key: "expeditionDate",
        type: "calendar",
        col: 2
      },
      {
        key: "expirationDate",
        type: "calendar",
        col: 2
      },
      {
        key: "statusId",
        type: "dropdown",
        col: 2
      },
    ];

    case 'clone': return [
      {
        key: "nametoclone",
        type: "text",
        col: 1
      },
      {
        key: "key",
        type: "text",
        col: 1
      },
      {
        key: "keyLabelDescription",
        type: "textarea",
        col: 1
      },
      {
        key: "isAdministrative",
        type: "radioButton",
        col: 1
      },
      {
        key: "parentId",
        type: "dropdown",
        col: 1
      },
      {
        key: "codetoclone",
        type: "text",
        col: 2
      },
      {
        key: "code",
        type: "text",
        col: 2
      },
      {
        key: "categoryId",
        type: "dropdown",
        col: 2
      },
      {
        key: "keyLabel",
        type: "dropdown",
        col: 2
      },
      {
        key: "expeditionDate",
        type: "calendar",
        col: 2
      },
      {
        key: "expirationDate",
        type: "calendar",
        col: 2
      },
    ];

    default: return [
      {
        key: "key",
        type: "text",
        col: 1
      },
      {
        key: "code",
        type: "text",
        col: 1
      },
      {
        key: "keyLabelDescription",
        type: "textarea",
        col: 1
      },
      {
        key: "isAdministrative",
        type: "radioButton",
        col: 1
      },
      {
        key: "parentId",
        type: "dropdown",
        col: 1
      },
      {
        key: "categoryId",
        type: "dropdown",
        col: 2
      },
      {
        key: "keyLabel",
        type: "dropdown",
        col: 2
      },
      {
        key: "expeditionDate",
        type: "calendar",
        col: 2
      },
      {
        key: "expirationDate",
        type: "calendar",
        col: 2
      }
    ]
  }
};

export const rolesFieldsSelecter = (action: string) => {
  switch (action) {
    case 'detail': return [
      {
        key: "tenantname",
        type: "text",
        col: 1,
      },
      {
        key: "name",
        type: "text",
        col: 1,
      },
      {
        key: "description",
        type: "textarea",
        col: 1,
      },
      {
        key: "startDate",
        type: "text",
        col: 2,
      },
      {
        key: "endDate",
        type: "text",
        col: 2,
      },
      {
        key: "status",
        type: "dropdown",
        col: 2,
      },
    ];
    case 'update': return [
      {
        key: "tenantname",
        type: "text",
        col: 1,
      },
      {
        key: "name",
        type: "text",
        col: 1,
      },
      {
        key: "description",
        type: "textarea",
        col: 1,
      },
      {
        key: "startDate",
        type: "calendar",
        col: 2,
      },
      {
        key: "endDate",
        type: "calendar",
        col: 2,
      },
      {
        key: "status",
        type: "dropdown",
        col: 2,
      },
    ];

    case 'clone': return [
      {
        key: "tenantname",
        type: "text",
        col: 1,
      },
      {
        key: "nametoclone",
        type: "text",
        col: 1,
      },
      {
        key: "newname",
        type: "text",
        col: 1,
      },
      {
        key: "description",
        type: "textarea",
        col: 2,
      },
      {
        key: "startDate",
        type: "calendar",
        col: 2,
      },
      {
        key: "endDate",
        type: "calendar",
        col: 2,
      },
    ];

    default: return [
      {
        key: "tenantname",
        type: "text",
        col: 1,
      },
      {
        key: "name",
        type: "text",
        col: 1,
      },
      {
        key: "description",
        type: "textarea",
        col: 1,
      },
      {
        key: "startDate",
        type: "calendar",
        col: 2,
      },
      {
        key: "endDate",
        type: "calendar",
        col: 2,
      },
    ];
  }
};

export const permissionsFieldsSelecter = (action: string) => {
  switch (action) {
    case 'detail': return [
      {
        key: "functionalityId",
        type: "dropdown",
        col: 1
      },
      {
        key: "privilegeId",
        type: "dropdown",
        col: 1
      },
      {
        key: "protocolId",
        type: "dropdown",
        col: 1
      },
      {
        key: "port",
        type: "text",
        col: 1
      },
      {
        key: "methodId",
        type: "dropdown",
        col: 2
      },
      {
        key: "pagePath",
        type: "textarea",
        col: 2
      },
      {
        key: "servicePath",
        type: "textarea",
        col: 2
      },
      {
        key: "expeditionDate",
        type: "text",
        col: 2
      },
      {
        key: "expirationDate",
        type: "text",
        col: 2
      },
      {
        key: "statusId",
        type: "dropdown",
        col: 2
      },
    ];

    case 'update': return [
      {
        key: "functionalityId",
        type: "dropdown",
        col: 1
      },
      {
        key: "privilegeId",
        type: "dropdown",
        col: 1
      },
      {
        key: "protocolId",
        type: "dropdown",
        col: 1
      },
      {
        key: "port",
        type: "text",
        col: 1
      },
      {
        key: "methodId",
        type: "dropdown",
        col: 2
      },
      {
        key: "pagePath",
        type: "textarea",
        col: 2
      },
      {
        key: "servicePath",
        type: "textarea",
        col: 2
      },
      {
        key: "expeditionDate",
        type: "calendar",
        col: 2
      },
      {
        key: "expirationDate",
        type: "calendar",
        col: 2
      },
      {
        key: "statusId",
        type: "dropdown",
        col: 2
      },
    ];

    case 'clone': return [
      {
        key: "functionalityId",
        type: "dropdown",
        col: 1
      },
      {
        key: "privilegetoclone",
        type: "dropdown",
        col: 1
      },
      {
        key: "privilegeId",
        type: "dropdown",
        col: 1
      },
      {
        key: "protocolId",
        type: "dropdown",
        col: 1
      },
      {
        key: "port",
        type: "text",
        col: 1
      },
      {
        key: "methodId",
        type: "dropdown",
        col: 2
      },
      {
        key: "pagePath",
        type: "textarea",
        col: 2
      },
      {
        key: "servicePath",
        type: "textarea",
        col: 2
      },
      {
        key: "expeditionDate",
        type: "calendar",
        col: 2
      },
      {
        key: "expirationDate",
        type: "calendar",
        col: 2
      },
    ];

    default: return [
      {
        key: "functionalityId",
        type: "dropdown",
        col: 1
      },
      {
        key: "privilegeId",
        type: "dropdown",
        col: 1
      },
      {
        key: "protocolId",
        type: "dropdown",
        col: 1
      },
      {
        key: "port",
        type: "text",
        col: 1
      },
      {
        key: "methodId",
        type: "dropdown",
        col: 2
      },
      {
        key: "pagePath",
        type: "textarea",
        col: 2
      },
      {
        key: "servicePath",
        type: "textarea",
        col: 2
      },
      {
        key: "expeditionDate",
        type: "calendar",
        col: 2
      },
      {
        key: "expirationDate",
        type: "calendar",
        col: 2
      },
    ];
  }
};

export const ORDER_PERMISSIONS = process.env["REACT_APP_ORDER_PERMISSIONS_ROLES"]
  ? JSON.parse(process.env["REACT_APP_ORDER_PERMISSIONS_ROLES"])
  : ['READ', 'CREATE', 'UPDATE', 'REMOVE'];

export const infoCreateLabelsFields = [
  {
    key: "type",
    type: "dropdown",
    col: 1
  },
  {
    key: "key",
    type: "text",
    col: 1
  },
  {
    key: "description",
    type: "textarea",
    col: 1
  },
  {
    key: "esvalue",
    type: "textarea",
    col: 1
  },
  {
    key: "envalue",
    type: "textarea",
    col: 1
  },
  {
    key: "releaseversion",
    type: "dropdown",
    col: 1
  },
];

export const FieldsLinkedTocreateLabelsButton = ['labelkey', 'keyLabel'];

export const urlContexts: {
  console: string;
  servicepoint: string;
  mastercatalog: string;
  iam_back: string;
  iam_front: string;
  auditory: string;
  roles: string;
} = process.env?.REACT_APP_URL_CONTEXT
    ? JSON.parse(process.env["REACT_APP_URL_CONTEXT"])
    : {
      console: "console-configurations",
      servicepoint: "servicepoint",
      mastercatalog: "mastercatalog",
      iam_back: "mcvs-iam",
      iam_front: "iuvity-iam",
      auditory: "mcvs-iuvibanking-console-audit",
      roles: "roles",
    };

export const infoUsersFields = [
  {
    key: "firstName",
    type: "text",
    col: 1
  },
  {
    key: "lastName",
    type: "text",
    col: 1
  },
  {
    key: "location",
    type: "dropdown",
    col: 1
  },
  {
    key: "function",
    type: "dropdown",
    col: 2
  },
  {
    key: "email",
    type: "text",
    col: 2
  },
  {
    key: "secondaryEmail",
    type: "text",
    col: 2
  },
];

export const infoUsersDetailFields = [
  {
    key: "lastAccessDate",
    type: "text",
    col: 1
  },
  {
    key: "firstName",
    type: "text",
    col: 1
  },
  {
    key: "lastName",
    type: "text",
    col: 1
  },
  {
    key: "location",
    type: "dropdown",
    col: 1
  },
  {
    key: "function",
    type: "dropdown",
    col: 2
  },
  {
    key: "email",
    type: "text",
    col: 2
  },
  {
    key: "secondaryEmail",
    type: "text",
    col: 2
  },

  {
    key: "createdAt",
    type: "text",
    col: 2
  },
  {
    key: "status",
    type: "dropdown",
    col: 2
  },
];
export const infoDeletedUserFields = [
  {
    key: "lastAccessDate",
    type: "text",
    col: 1
  },
  {
    key: "firstName",
    type: "text",
    col: 1
  },
  {
    key: "lastName",
    type: "text",
    col: 1
  },
  {
    key: "location",
    type: "dropdown",
    col: 1
  },
  {
    key: "function",
    type: "dropdown",
    col: 2
  },
  {
    key: "email",
    type: "text",
    col: 2
  },
  {
    key: "secondaryEmail",
    type: "text",
    col: 2
  },
  {
    key: "deletedAt",
    type: "text",
    col: 2
  },
  {
    key: "status",
    type: "text",
    col: 2
  },
];

export const infoRoleDetailFields = [
  {
    key: "name",
    type: "text",
    col: 1
  },
  {
    key: "roleTypeId",
    type: "text",
    col: 1
  },
  {
    key: "expeditionDate",
    type: "text",
    col: 2
  },
  {
    key: "expirationDate",
    type: "text",
    col: 2
  }
];

export const functionalitiesCodesExtras = {
  "/products/properties": "COD_PDP",
  "/products/cross_configs": "COD_CTDP",
  "/transactions/properties": "COD_TRANSPROP",
};

export const ALIAS_PARENT = 'ALIAS::PARENT';